import script from "./PrecosComerciaisAdministrar.vue?vue&type=script&setup=true&lang=js"
export * from "./PrecosComerciaisAdministrar.vue?vue&type=script&setup=true&lang=js"

import "./PrecosComerciaisAdministrar.vue?vue&type=style&index=0&id=1715238e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1715238e"]])

export default __exports__